import React from 'react';

const ArticleContent = ({ content }) => {
  if (!content) return null;

  return (
    <div
      style={{
        fontFamily: 'Georgia, serif',
        fontSize: '1.05rem',
        lineHeight: 1.85,
        color: 'rgba(238,240,242,0.85)',
        maxWidth: '720px'
      }}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};

export default ArticleContent;
